import * as urlUtils from 'utils/Url';


export function getPathReviewsOverview(qs={}) {
  return urlUtils.appendQueryString(`/reviews-overview`, qs);
}

export function getPathReviewsAnalytics(qs={}) {
  return urlUtils.appendQueryString(`/reviews-analytics`, qs);
}

export function getPathReviewsConnections(qs={}) {
  return urlUtils.appendQueryString(`/reviews-connections`, qs);
}

export function getPathAddReviewsConfig() {
  return `/reviews-config/add`;
}

export function getPathEditReviewsConfig() {
  return `/reviews-config/edit`;
}

export function getPathEditReviewsEmails() {
  return `/reviews-emails/edit`;
}

export function getPathReviewsEmails(qs={}) {
  return urlUtils.appendQueryString(`/reviews-emails`, qs);
}

export function getPathReviewsEmailRecipients(emailId, qs={}) {
  return urlUtils.appendQueryString(`/reviews-emails/${emailId}/recipients`, qs);
}

export function getPathReviewsEmailAnalytics(emailId, qs={}) {
  return urlUtils.appendQueryString(`/reviews-emails/${emailId}/analytics`, qs);
}

export function getPathReviewsEmailConversions(emailId, qs={}) {
  return urlUtils.appendQueryString(`/reviews-emails/${emailId}/conversions`, qs);
}

export function getPathProductReviews(qs={}) {
  return urlUtils.appendQueryString(`/product-reviews`, qs);
}

export function getPathSiteReviews(qs={}) {
  return urlUtils.appendQueryString(`/site-reviews`, qs);
}

export function getPathReviewsCollectors(qs={}) {
  return urlUtils.appendQueryString(`/reviews-collectors`, qs);
}

export function getPathAddReviewsCollector() {
  return `/reviews-collectors/add`;
}

export function getPathEditReviewsCollector(collectorId) {
  return `/reviews-collectors/${collectorId}/edit`;
}

export function getPathReplicateReviewsCollector(collectorId) {
  return `/reviews-collectors/${collectorId}/replicate`;
}

export function getPathReviewsWidgets(qs={}) {
  return urlUtils.appendQueryString(`/reviews-widgets`, qs);
}

export function getPathAddReviewsWidget() {
  return `/reviews-widgets/add`;
}

export function getPathEditReviewsWidget(widgetId) {
  return `/reviews-widgets/${widgetId}/edit`;
}

export function getPathReplicateReviewsWidget(widgetId) {
  return `/reviews-widgets/${widgetId}/replicate`;
}

export function getPathStarRatings(qs={}) {
  return urlUtils.appendQueryString(`/star-ratings`, qs);
}

export function getPathAddStarRating() {
  return `/star-ratings/add`;
}

export function getPathEditStarRating(starRatingId) {
  return `/star-ratings/${starRatingId}/edit`;
}

export function getPathReplicateStarRating(starRatingId) {
  return `/star-ratings/${starRatingId}/replicate`;
}

export function getPathBigCommerceReviews(qs={}) {
  return urlUtils.appendQueryString(`/bigcommerce-reviews`, qs);
}
